<template>
  <div style="font-family: 'Prompt', sans-serif">
    <b-table
      v-if="readonly"
      stacked
      borderless
      class="border"
      :fields="[
        { duration: 'ระยะเวลาเรียน :' },
        { price: 'ราคาคอร์ส :' },
        { promotion: 'ระยะเวลาโปรโมชั่น :' },
      ]"
      :items="[courseInfo]"
    >
      <template v-slot:cell(duration)="data">
        <span v-if="data.item.startLearningDate && data.item.finishLearningDate">
          {{ data.item.startLearningDate | formatDate }} - {{ data.item.finishLearningDate | formatDate }}
        </span>
        <span v-else-if="data.item.learnDuration">
          {{ data.item.learnDuration | formatNumber }} วัน
        </span>
        <span v-else>ไม่จำกัดวันเรียน</span>

        <span v-if="data.item.learnTimeLimit">
          (ไม่เกิน {{ data.item.learnTimeLimit | formatNumber }} ชั่วโมง)
        </span>
        <span v-else>ไม่จำกัดชั่วโมงเรียน</span>
      </template>
      <template v-slot:cell(price)="data">
        <div v-if="data.item.price">
          {{ data.item.price | formatNumber }} บาท
          <span
            v-if="
              data.item.promotionPrice && data.item.allTimeSeasonPrice.enable === false
            "
            class="small"
          >
            (ลดเหลือ {{ data.item.promotionPrice | formatNumber }} บาท)
          </span>
          <span
            v-if="data.item.allTimeSeasonPrice.price && data.item.allTimeSeasonPrice.enable"
            class="small"
          >
            (ลดเหลือ {{ data.item.allTimeSeasonPrice.price | formatNumber }} บาท)
          </span>
        </div>
        <div v-else>ฟรี</div>
      </template>
      <template v-slot:cell(promotion)="data">
        <div v-if="data.item.allTimeSeasonPrice.price && data.item.allTimeSeasonPrice.enable">
          {{ data.item.allTimeSeasonPrice.startDate | formatDate }}<span> - </span>
          {{ data.item.allTimeSeasonPrice.endDate | formatDate }}
        </div>
        <div v-else>-</div>
      </template>
    </b-table>
    <b-form v-else id="course-price" @submit="onSubmit">
      กำหนดระยะเวลาเรียน
      <div class="d-flex">
        <div class="learn-date-type left" @click="learnDateType = 'day';" :class="{ active: learnDateType === 'day' }">
          <h6 class="mb-0">จำนวนวัน</h6>
        </div>
        <div class="learn-date-type right" @click="learnDateType = 'dateRange';" :class="{ active: learnDateType === 'dateRange' }">
          <h6 class="mb-0">วันที่เริ่ม/จบ</h6>
        </div>
      </div>

      <template v-if="learnDateType === 'day'">
        <b-row class="mt-4">
          <b-col>
            <b-form-group label="ระยะเวลาเรียน *">
              <b-input-group append="วัน">
                <b-form-input
                  v-model="form.learnDuration"
                  placeholder="ไม่จำกัด"
                  :readonly="readonly"
                  :value="courseInfo.learnDuration"
                  :state="checkValidLearnDuration"
                ></b-form-input>
              </b-input-group>
              <div
                v-if="checkValidLearnDuration === false"
                class="mt-1 text-danger"
                :style="{ fontSize: '0.8rem' }"
              >
                <span>จำนวนวันไม่ถูกต้อง</span>
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="จำนวนชั่วโมงจำกัด">
              <b-input-group append="ชั่วโมง">
                <b-form-input
                  v-model="form.learnTimeLimit"
                  placeholder="ไม่จำกัด"
                  :value="courseInfo.learnTimeLimit"
                  :readonly="readonly"
                  :state="checkValidLearnTimeLimit"
                ></b-form-input>
              </b-input-group>
              <div
                v-if="checkValidLearnTimeLimit === false"
                class="mt-1 text-danger"
                :style="{ fontSize: '0.8rem' }"
              >
                <span>กรุณากรอกจำนวนชั่วโมงที่ถูกต้อง</span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-row class="mt-4">
          <b-col>
            <b-form-group label="วันที่เริ่ม *">
              <b-form-datepicker
                v-model="form.startLearningDate"
                :value="courseInfo.startLearningDate"
                :disabled="readonly"
                locale="th"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                :state="checkValidDateRange"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="วันที่สิ้นสุด *">
              <b-form-datepicker
                v-model="form.finishLearningDate"
                :value="courseInfo.finishLearningDate"
                :disabled="readonly"
                locale="th"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                :state="checkValidDateRange"
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="จำนวนชั่วโมงจำกัด">
              <b-input-group append="ชั่วโมง">
                <b-form-input
                  v-model="form.learnTimeLimit"
                  placeholder="ไม่จำกัด"
                  :value="courseInfo.learnTimeLimit"
                  :readonly="readonly"
                  :state="checkValidLearnTimeLimit"
                ></b-form-input>
              </b-input-group>
              <div
                v-if="checkValidLearnTimeLimit === false"
                class="mt-1 text-danger"
                :style="{ fontSize: '0.8rem' }"
              >
                <span>กรุณากรอกจำนวนชั่วโมงที่ถูกต้อง</span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="checkValidDateRange === false">
          <b-col>
            <div class="mt-1 text-danger" :style="{ fontSize: '0.8rem' }">
              <span>กรุณากรอกวันที่ให้ถูกต้อง</span>
            </div>
          </b-col>
        </b-row>
      </template>

      <hr>

      <b-row class="mt-4">
        <b-col>
          <b-form-group label="ราคาเต็ม *">
            <b-input-group append="บาท">
              <b-form-input
                v-model="price"
                :value="courseInfo.price"
                placeholder="ฟรี"
                :readonly="readonly"
                :formatter="editPrice"
              ></b-form-input>
            </b-input-group>
            <template v-slot:description>
              <div v-if="false" class="d-flex justify-content-between">
                <span>
                  {{ form.price | countVat | formatNumber }}
                  บาท ไม่รวมภาษี
                </span>
              </div>
            </template>
          </b-form-group>
        </b-col>
        <b-col v-if="comId != 505 && !isHideCoursePriceManagement">
          <b-form-group label="ราคาลด (ราคาขายจริง)">
            <b-input-group prepend="ลดเหลือ" append="บาท">
              <b-form-input
                v-model="form.promotionPrice"
                :value="courseInfo.promotionPrice"
                :placeholder="price"
                :readonly="readonly"
                :formatter="editPrice"
                :state="checkVaildPromotionPrice"
              ></b-form-input>
            </b-input-group>
            <div
              v-if="checkVaildPromotionPrice === false"
              class="mt-1 text-danger"
              :style="{ fontSize: '0.8rem' }"
            >
              <span> ราคาลดต้องน้อยกว่าราคาเต็ม </span>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-if="comId != 505 && !isHideCoursePriceManagement">
        <b-col>
          <b-form-group>
            <b-form-checkbox switch class="mb-2" v-model="isPromotion">
              ราคาลดพิเศษ (ระบุช่วงโปรโมชั่น)
            </b-form-checkbox>
            <b-input-group prepend="ลดเหลือ" append="บาท">
              <b-form-input
                v-model="seasonPrice"
                :value="courseInfo.allTimeSeasonPrice.price"
                :readonly="readonly"
                :formatter="editPrice"
                :disabled="isPromotion == false"
                :state="checkVaildSeasonPrice"
                aria-describedby="input-season-price"
              >
              </b-form-input>
            </b-input-group>
            <template v-slot:description>
              <div v-if="false" class="d-flex justify-content-between">
                <span>
                  {{ form.allTimeSeasonPrice.price | countVat | formatNumber }}
                  บาท ไม่รวมภาษี
                </span>
              </div>
            </template>
            <div
              v-if="checkVaildSeasonPrice === false"
              class="mt-1 text-danger"
              :style="{ fontSize: '0.8rem' }"
            >
              <span> ราคาลดพิเศษต้องน้อยกว่าราคาเต็มและราคาลด และไม่เท่ากับ 0 </span>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="วันที่เริ่มโปรโมชั่น">
            <b-form-input
              v-model="coursePriceStartDate"
              type="date"
              :min="dateFormat"
              :max="coursePriceEndDate"
              :readonly="readonly"
              :disabled="isPromotion == false"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="วันที่สิ้นสุดโปรโมชั่น">
            <b-form-input
              v-model="coursePriceEndDate"
              type="date"
              :min="coursePriceStartDate"
              :readonly="readonly"
              :disabled="isPromotion == false"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mt-2" v-if="isPromotion">
          <b-form-group label="นับวันเรียน">
            <b-form-radio-group
              id="radio-check-learning"
              v-model="startDateType"
              stacked
            >
              <b-form-radio value="START_LEARNING"
                >วันที่เข้าเรียนวันแรก
                <span
                  :class="[
                    startDateType === 'START_LEARNING' && checkValidStartLearningSeasonPrice
                      ? 'text-danger text-sm'
                      : 'd-none',
                  ]"
                  >*ราคาลดพิเศษควรมากกว่าราคาลด(ราคาขายจริง) </span
                ></b-form-radio
              >
              <b-form-radio value="ENROLL"
                >วันที่ลงทะเบียน
                <span :class="[
                    startDateType === 'ENROLL' && checkValidEnrollSeasonPrice
                      ? 'text-danger text-sm'
                      : 'd-none',
                  ]"
                  >*ราคาลดพิเศษควรน้อยกว่าราคาลด(ราคาขายจริง)</span
                >
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="!readonly" class="text-right">
        <b-button
          class="mt-4"
          type="submit"
          variant="primary"
          :disabled="
            checkVaildPromotionPrice === false || 
            checkVaildSeasonPrice === false ||
            (learnDateType === 'day' && (checkValidLearnDuration === false || checkValidLearnTimeLimit === false)) ||
            (learnDateType === 'dateRange' && (checkValidDateRange === false || checkValidLearnTimeLimit === false))
          "
          >บันทึก</b-button
        >
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Numeral from "numeral";
import moment from "moment";
import CustomUserPermissionMixin from "@/mixins/custom-user-permission-mixin.js";

export default {
  name: "PricingForm",
  mixins: [CustomUserPermissionMixin],
  filters: {
    countVat: function (value) {
      return value / 1.07;
    },

    formatNumber: function (value) {
      return Numeral(value).format("0,00");
    },

    formatDate: function (value) {
      if (value) {
        moment.updateLocale("th", {});
        let year = parseInt(moment(String(value)).format("YYYY"));
        year += 543;
        return moment(String(value)).format(`D MMM ${year}`);
      }
    },
  },
  props: {
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      comId: JSON.parse(localStorage.getItem("ComId")),
      memberId: JSON.parse(localStorage.getItem("user")).id,
      form: {
        exCoursePrice: 0,
        curCoursePrice: 0,
        coursePriceStartDate: null,
        coursePriceEndDate: null,
      },
      dateFormat: moment().format("YYYY-MM-DD"),
      periodDateFrom: moment().subtract(1, "month").format("YYYY-MM-DD"),
      learnDateType: "day",
      isInitialized: false,
    };
  },
  mounted() {
    if (this.courseInfo.startLearningDate && this.courseInfo.finishLearningDate) {
      this.learnDateType = "dateRange";
    } else {
      this.learnDateType = "day";
    }
    this.isInitialized = true;
  },
  computed: {
    ...mapGetters("CourseManagement", ["isLoading", "courseInfo"]),
    coursePriceStartDate: {
      get() {
        const date =
          this.form.allTimeSeasonPrice.startDate || moment().format("YYYY-MM-DD");
        return moment(date).format("YYYY-MM-DD");
      },
      set(val) {
        this.form.allTimeSeasonPrice.startDate = val;
      },
    },
    coursePriceEndDate: {
      get() {
        const date =
          this.form.allTimeSeasonPrice.endDate ||
          moment().add(7, "days").format("YYYY-MM-DD");

        return moment(date).format("YYYY-MM-DD");
      },
      set(val) {
        this.form.allTimeSeasonPrice.endDate = val;
      },
    },
    price: {
      get() {
        return Numeral(this.form.price).format("0,0");
      },
      set(val) {
        this.form.price = val.replace(/[^0-9]|e/g, "");
      },
    },

    startDateType: {
      get() {
        return this.form.allTimeSeasonPrice.startDateType;
      },
      set(val) {
        this.form.allTimeSeasonPrice.startDateType = val;
      },
    },
    seasonPrice: {
      get() {
        return this.isPromotion
          ? Numeral(this.form.allTimeSeasonPrice.price).format("0,0")
          : Numeral(0).format("0,0");
      },
      set(val) {
        this.form.allTimeSeasonPrice.price = val.replace(/[^0-9]|e/g, "");
      },
    },
    curCoursePrice() {
      let curCoursePrice = 0;

      if (this.form.price > 0) {
        if (
          this.form.allTimeSeasonPrice.price > this.form.price ||
          !this.isPromotion
        ) {
          curCoursePrice =
            this.form.promotionPrice != null
              ? this.form.promotionPrice
              : this.form.price;
        } else {
          curCoursePrice = this.form.allTimeSeasonPrice.price;
        }
      }
      return curCoursePrice;
    },
    isPromotion: {
      get() {
        return this.form.allTimeSeasonPrice.enable; //cast int to boolean
      },
      set(hasPromotion) {
        this.form.allTimeSeasonPrice.enable = hasPromotion;
        if (hasPromotion) {
          this.form.allTimeSeasonPrice.price =
            this.form.allTimeSeasonPrice.price != null
              ? this.form.allTimeSeasonPrice.price
              : this.form.price;
          this.form.allTimeSeasonPrice.startDate = moment().format("YYYY-MM-DD");
          this.form.allTimeSeasonPrice.endDate = moment().add(7, "days").format("YYYY-MM-DD");
        }
        return hasPromotion;
      },
    },
    checkVaildPromotionPrice() {
      let cPromoPrice = null;
      if (this.form.promotionPrice !== null) {
        cPromoPrice =
          Numeral(this.form.promotionPrice).value() === 0
            ? false
            : Numeral(this.form.promotionPrice).value() >=
              Numeral(this.form.price).value()
            ? false
            : true;
      }
      return cPromoPrice;
    },
    checkVaildSeasonPrice() {
      let state = null;
      if (this.isPromotion) {
        if (this.seasonPrice <= 0) {
          state = false;
        } else if (Numeral(this.form.promotionPrice).value()) {
          state =
            Numeral(this.form.allTimeSeasonPrice.price).value() >=
            Numeral(this.form.promotionPrice).value()
              ? false
              : true;
        } else {
          state =
            Numeral(this.form.allTimeSeasonPrice.price).value() >= Numeral(this.form.price).value()
              ? false
              : true;
        }
      }
      return state;
    },
    checkValidEnrollSeasonPrice() {
      if (this.form.promotionPrice) {
        return Numeral(this.form.allTimeSeasonPrice.price).value() > Numeral(this.form.promotionPrice).value()
          ? true
          : false;
      }
      return false
    },
    checkValidStartLearningSeasonPrice() {
      return Numeral(this.form.allTimeSeasonPrice.price).value() < Numeral(this.form.promotionPrice).value()
        ? true
        : false;
    },
    checkValidLearnDuration() {
      let state = null;
      if (this.form.learnDuration !== null && this.form.learnDuration !== '') {
        const value = Numeral(this.form.learnDuration).value(); // Numeral returns null for non-numeric values
        if (value === null || value < 0) {
          state = false;
        }
      }
      return state;
    },
    checkValidLearnTimeLimit() {
      let state = null;
      if (this.form.learnTimeLimit !== null && this.form.learnTimeLimit !== '') {
        const raw = String(this.form.learnTimeLimit).trim();
        if (!/^\d+$/.test(raw) || Number(raw) < 0) {
          state = false;
        }
      }
      return state;
    },
    checkValidDateRange() {
      let state = null;
      const hasStart = !!this.form.startLearningDate;
      const hasFinish = !!this.form.finishLearningDate;
      if (hasStart && hasFinish) {
        state = moment(this.form.finishLearningDate).isBefore(moment(this.form.startLearningDate))
          ? false
          : null;
      } else if (hasStart !== hasFinish) {
        state = false;
      }
      return state;
    },
    
  },
  watch: {
    learnDateType(newValue) {
      if (!this.isInitialized) return;
      
      if (newValue === 'day') {
        this.form.startLearningDate = null;
        this.form.finishLearningDate = null;
      } else if (newValue === 'dateRange') {
        this.form.learnDuration = null;
      }
    },
  },
  created() {
    this.form = JSON.parse(JSON.stringify(this.courseInfo));
    if (this.form.promotionPrice !== null) {
      this.form.promotionPrice = Numeral(parseInt(this.form.promotionPrice)).format("0,0");
    }
  },
  methods: {
    ...mapActions("CourseManagement", [
      "updateCoursePrice",
      "getCourseInfo",
      "updateCourseInfo",
      "updateCoursePriceSeason",
    ]),
    editPrice(value) {
      var newValue = value.replace(/[^0-9]|e/g, "");
      if (isNaN(parseInt(newValue))) {
        return newValue;
      } else {
        return Numeral(parseInt(newValue)).format("0,0");
      }
    },
    async onSubmit(evt) {
      evt.preventDefault();
      await this.updateCoursePrice({
        courseId: this.$route.params.courseId,
        payloads: {
          courseLearnDuration: this.form.allTimeSeasonPrice.enable
            ? this.form.allTimeSeasonPrice.learnDuration
            : this.form.learnDuration,
          courseLearnTimeLimit: this.form.allTimeSeasonPrice.enable
            ? this.form.allTimeSeasonPrice.learnTimeLimit
            : this.form.learnTimeLimit,
          exCoursePrice: this.form.price || 0,
          curCoursePrice: this.curCoursePrice || 0,
          coursePriceStartDate:
            this.form.allTimeSeasonPrice.startDate || moment().format("YYYY-MM-DD"),
          coursePriceEndDate:
            this.form.allTimeSeasonPrice.endDate ||
            moment().add(7, "days").format("YYYY-MM-DD"),
        },
      });
      await this.updateCourseInfo({
        courseId: this.$route.params.courseId,
        attribute: {
          price: this.form.price,
          learnDuration: this.form.learnDuration,
          learningPeriodInDay: this.form.learnDuration,
          startLearningDate: this.form.startLearningDate,
          finishLearningDate: this.form.finishLearningDate,
          learnTimeLimit: this.form.learnTimeLimit,
          promotionPrice: Numeral(this.form.promotionPrice).value(),
        },
      });
      await this.updateCoursePriceSeason({
        courseId: this.$route.params.courseId,
        payloads: {
          learnDuration:
            this.form.allTimeSeasonPrice.enable // if season price is enabled
            ? this.form.learnDuration // use learn duration filled in form
            : this.form.allTimeSeasonPrice.learnDuration, // else, use learn duration from existing value (hidden in form)
          learnTimeLimit:
            this.form.allTimeSeasonPrice.enable
            ? this.form.learnTimeLimit
            : this.form.allTimeSeasonPrice.learnTimeLimit,
          enable: this.form.allTimeSeasonPrice.enable,
          price: this.form.allTimeSeasonPrice.price || this.form.price,
          startDate:
            this.form.allTimeSeasonPrice.startDate || moment().format("YYYY-MM-DD"),
          endDate:
            this.form.allTimeSeasonPrice.endDate ||
            moment().add(7, "days").format("YYYY-MM-DD"),
          startDateType: this.form.allTimeSeasonPrice.startDateType,
        },
      }).then(() => {
        this.$emit("toggle-modal", "coursePriceModal");
      });
    },
  },
};
</script>
<style scoped>
#radio-check-learning .custom-radio {
  margin-bottom: 0.5rem;
}
.text-sm {
  font-size: 14px;
}
table td {
  font-family: "Prompt", sans-serif !important;
}

.learn-date-type {
  padding: 6px 20px;
  color: #525252;
  border: 1px solid rgba(82, 82, 82, 0.2);
  height: calc(1.5em + 0.75rem + 2px);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.learn-date-type.active {
  background: #007bff;
  color: #fff;
}

.learn-date-type.left {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.learn-date-type.right {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-left: 0px solid #707070;
}
</style>